import { FormControl, ValidatorFn } from '@angular/forms';

export function validateArrayHasTruthyEntitiesFactory(): ValidatorFn {
  return (c: FormControl) =>
    Array.isArray(c.value) && c.value.filter(v => !!v).length ? null : { arrayNotEmpty: { valid: false } };
}
